import {Injectable} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {ToastService} from "./toast/toast.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({providedIn: "root"})
export class ErrorhandlerService {
  constructor(private toastService: ToastService,
              private translate: TranslateService) {
  }

  async errorHandler(error: HttpErrorResponse) {
    if (error && error?.error && error?.error?.errorCode) {
      setTimeout(async () => {
        const errorMessage = await firstValueFrom(this.translate.get(error?.error?.errorCode));
        this.toastService.showToast(errorMessage);
      })
    } else {
      const errorMessage = await firstValueFrom(this.translate.get("ERROR"));
      this.toastService.showToast(errorMessage);
    }

  }
}
